import { CloseOutlined } from '@ant-design/icons';
import React from 'react';

import { useTheme } from 'styled-components';

import { Text } from 'src/client/components';
import { PageRecipient } from 'src/commons/types';

import * as S from './styles';

type Props = {
  selectedRecipients: PageRecipient[];
  onRemoveRecipient: (recipientId: string) => void;
};

function SelectedRecipients(props: Props) {
  const { selectedRecipients, onRemoveRecipient } = props;
  const { colors } = useTheme();

  const isEmpty = selectedRecipients.length === 0;

  if (isEmpty) {
    return (
      <S.Container>
        <S.EmptyState>
          <Text color={colors.darkEmphasis2} type="body2reg2">
            No selected recipients yet.
          </Text>
        </S.EmptyState>
      </S.Container>
    );
  }

  return (
    <S.Container>
      <S.RecipientChipsContainer>
        {selectedRecipients.map((recipient) => (
          <S.RecipientChip key={recipient.id}>
            <S.RecipientName type="body2med2">
              {recipient.recipientName}
            </S.RecipientName>
            <S.RemoveButton
              aria-label={`Remove ${recipient.recipientName}`}
              onClick={() => onRemoveRecipient(recipient.id)}
            >
              <CloseOutlined />
            </S.RemoveButton>
          </S.RecipientChip>
        ))}
      </S.RecipientChipsContainer>
    </S.Container>
  );
}

export default SelectedRecipients;
